import { Action, ActionType } from "../model";
import { User } from "../model/user";
import { Account } from "../model/account";
import createReducer from "./createReducer";

export const auth = createReducer({}, {
	[ActionType.LOGIN](state: User, action: Action<User>) {
		return action.payload;
	},
	[ActionType.USER_DETAILS](state: User, action: Action<Account>) {
		return {
			...state,
			user: action.payload
		}
	},
	[ActionType.LOGOUT](state: User, action: Action<any>) {
		return action.payload;
	},
	[ActionType.DEMO_CLIENT](state: User, action: Action<any>) {
		return {
			...state,
			user: action.payload.user
		}
	},
	[ActionType.EXIT_DEMO_CLIENT](state: User, action: Action<any>) {
		return {
			...state,
			user: action.payload.user
		}
	},
	[ActionType.PARENT_PORTAL](state: User, action: Action<any>) {
		state.parentPortal = action.payload
		return {...state}
	},
    [ActionType.SERVICE_LOGGED_IN](state: User, action: Action<any>) {
        if(state.user && state.user.client){
            state.user.client.serviceLoggedIn = action.payload
        }
        return {...state}
    },
    [ActionType.REFRESH_APPLICATION](state: User, action: Action<any>) {
        return {
            ...state
        }
    }
});
